import { Button, Banner, Text, Flex } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { ExternalLink } from '@common';

import { useGlobalUI } from '@/components/GlobalUIProvider';
import ABMModal from '@/components/ABMManagement/ABMModal';
import { getLocalizedAppleUrl } from '@/helpers/getLocalizedAppleUrl';

const UnconnectedMessage = () => {
  const { t } = useTranslation('getting-started');
  const { openModal, closeModal } = useGlobalUI();
  return (
    <Text>
      {t('abmUnconnectedBanner.message')}
      <Flex columnGap="2rem" alignItems="center" mt="1rem">
        <ExternalLink
          id="abm-unconnected-banner-learn-more-apple-link"
          href={getLocalizedAppleUrl(
            'https://support.apple.com/guide/apple-business-manager/manage-device-suppliers-axmef1c47493/web'
          )}>
          {t('abmUnconnectedBanner.learnMore')}
        </ExternalLink>
        <Button
          variant="outline"
          intent="warning"
          onClick={() => openModal(<ABMModal onClose={closeModal} />)}
          id="abm-unconnected-banner-resolve-issue"
          testId="abm-unconnected-banner-resolve-issue">
          {t('abmUnconnectedBanner.resolveButton')}
        </Button>
      </Flex>
    </Text>
  );
};

const ABMUnconnectedBanner = () => {
  const { t } = useTranslation('getting-started');
  return (
    <Banner
      id="abm-unconnected-warning-banner"
      isFlat
      intent="warning"
      title={t('abmUnconnectedBanner.title')}
      message={() => <UnconnectedMessage />}
    />
  );
};

export default ABMUnconnectedBanner;
